import React from 'react';
import { sounds } from '@/utils/soundEffects';
import RippleEffect from './RippleEffect';

type AnimationType = 'click' | 'sparkle' | 'bounce' | 'ripple' | 'shine';

interface WithInteractiveAnimationProps {
  animation?: AnimationType;
  sound?: keyof typeof sounds;
  className?: string;
}

const withInteractiveAnimation = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  defaultAnimation: AnimationType = 'click'
) => {
  return function WithInteractiveAnimationComponent({
    animation = defaultAnimation,
    sound,
    className = '',
    ...props
  }: P & WithInteractiveAnimationProps) {
    const getAnimationClass = () => {
      switch (animation) {
        case 'click':
          return 'active:animate-click-effect';
        case 'sparkle':
          return 'hover:animate-sparkle';
        case 'bounce':
          return 'hover:animate-bounce-in';
        case 'shine':
          return 'bg-gradient-to-r from-transparent via-white/10 to-transparent bg-[length:200%_100%] hover:animate-shine';
        default:
          return '';
      }
    };

    const handleInteraction = () => {
      if (sound) {
        sounds[sound]();
      }
    };

    return (
      <div className={`relative ${getAnimationClass()} ${className}`} onClick={handleInteraction}>
        <WrappedComponent {...(props as P)} />
        {animation === 'ripple' && <RippleEffect />}
      </div>
    );
  };
};

export default withInteractiveAnimation;